import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { request } from '@app/services';
import * as endpoints from './endpoints';
import {
  addInterviewee,
  addIntervieweeFailed,
  addIntervieweeSuccess,
  updateInterviewee,
  updateIntervieweeSuccess,
  updateIntervieweeFailed,
  getInterviewee,
  getIntervieweeSuccess,
  getIntervieweeFailed,
  promoteAsIntern,
  promoteAsInternSuccess,
  promoteAsInternFailed,
  updateIntervieweeStatus,
  updateIntervieweeStatusSuccess,
  updateIntervieweeStatusFailed,
  searchInterviewee,
  searchIntervieweeFailed,
  searchIntervieweeSuccess,
  getCandidateSearchSuccess,
  getCandidateSearchFailed,
  getCandidateSearch,
} from './slice';
import { RootState } from '@app/redux/root-reducer';

function* addIntervieweeSaga(action: ReturnType<typeof addInterviewee>): any {
  try {
    const { candidateName, candidateEmail, interviewer, interviewTime } = action.payload;
    const result = yield call(request.post, endpoints.addInterviewee, {
      candidateName,
      candidateEmail,
      interviewTime,
      interviewer,
    });
    yield put(addIntervieweeSuccess(result.data));
  } catch (err) {
    yield put(addIntervieweeFailed(err));
  }
}
function* updateIntervieweeSaga(action: ReturnType<typeof updateInterviewee>): any {
  try {
    const { id, candidateName, candidateEmail, interviewer, interviewTime } = action.payload;
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.put, `${endpoints.updateInterviewee}${id}`, {
      candidateName,
      candidateEmail,
      interviewTime,
      interviewer,
    });
    yield put(updateIntervieweeSuccess(result.data));
  } catch (err) {
    yield put(updateIntervieweeFailed(err));
  }
}

function* updateInterviweeStatusSaga(action: ReturnType<typeof updateIntervieweeStatus>): any {
  try {
    const { id, status, reason } = action.payload;
    const { data } = yield select((store: RootState) => store.IntervieweeReducer.Interviewee);
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.put, `${endpoints.updateIntervieweeStatus}${id}`, {
      status,
      reason,
    });
    yield put(updateIntervieweeStatusSuccess(result.data));
    const updateInterviewee = data?.map((interviewee: { id: number; status: string }) => {
      if (interviewee.id === id) {
        return {
          ...interviewee,
          status,
        };
      }
      return interviewee;
    });
    yield put(getIntervieweeSuccess(updateInterviewee));
  } catch (err) {
    yield put(updateIntervieweeStatusFailed(err));
  }
}

function* promoteAsInternSaga(action: ReturnType<typeof promoteAsIntern>): any {
  try {
    const { id } = action.payload;
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    const result = yield call(request.post, endpoints.promoteAsIntern + id);
    yield put(promoteAsInternSuccess(result.data.message));
  } catch (err) {
    yield put(promoteAsInternFailed(err));
  }
}

function* getIntervieweeSaga(action: ReturnType<typeof getInterviewee>): any {
  try {
    const result = yield call(request.get, endpoints.interviewee);
    yield put(getIntervieweeSuccess(result.data));
  } catch (err) {
    yield put(getIntervieweeFailed(err));
  }
}
//
function* searchIntervieweeSaga(action: ReturnType<typeof searchInterviewee>): any {
  try {
    const q = action.payload;
    const result = yield call(request.get, endpoints.searchInterviewee, {
      params: {
        q,
      },
    });
    yield put(searchIntervieweeSuccess(result.data));
  } catch (err) {
    yield put(searchIntervieweeFailed(err));
  }
}
//
function* getCandidateSearchSaga(action: ReturnType<typeof getCandidateSearch>): any {
  try {
    const q = action.payload;
    const result = yield call(request.get, endpoints.searchCandidateInterviewee, {
      params: {
        q,
      },
    });
    yield put(getCandidateSearchSuccess(result.data.candidates));
  } catch (err) {
    yield put(getCandidateSearchFailed(err));
  }
}
function* IntervieweeSagas() {
  yield all([
    takeLatest(
      [
        getInterviewee,
        updateIntervieweeSuccess,
        addIntervieweeSuccess,
        updateIntervieweeStatusSuccess,
      ],
      getIntervieweeSaga
    ),
    takeLatest(addInterviewee, addIntervieweeSaga),
    takeLatest(updateInterviewee, updateIntervieweeSaga),
    takeLatest(promoteAsIntern, promoteAsInternSaga),
    takeLatest(searchInterviewee, searchIntervieweeSaga),
    takeLatest(getCandidateSearch, getCandidateSearchSaga),
    takeLatest(updateIntervieweeStatus, updateInterviweeStatusSaga),
  ]);
}
export { IntervieweeSagas };
